// @flow

export type PlanActionType = {|
  type: 'SET_PLANS',
  payload: {|
    plans: Object[],
  |},
|};

export const setPlans = (plans: Object[]): PlanActionType => ({
  type: 'SET_PLANS',
  payload: {
    plans,
  },
});
